import React, { useEffect, useState } from "react";
import { CreateNewUser, GetAllRoleList, getCountryCodeList } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import Swal from "sweetalert2";
import './createUser.css';

const CreateUser = ({ setCreateUserModal, getAllData }) => {
  const [createUserForm, setCreateUserForm] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    username: "",
    password: "",
    mobileNumber: "",
    role: "",
  });
  const [error, setError] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [loaders, setLoaders] = useState({
    rolesLoader: false,
  });
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState('');
  const [countries, setCountries] = useState([]);

  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

  // Update phone regex based on selected country
  const getPhoneRegex = (length) => {
    return new RegExp(`^\\d{${length}}$`);
  };

  // Fetch country list and set default to India
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountryCodeList();
        if (response?.countryList) {
          setCountryList(response.countryList);
          // Find and set India as default
          const india = response.countryList.find(
            (country) => country.iso === "IN"
          );
          if (india) {
            setSelectedCountry(india);
          }
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
        setCountryList([]);
      }
    };
    fetchData();
  }, []);

  // Update handleSubmit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      emailId,
      username,
      password,
      mobileNumber,
      role,
    } = createUserForm;

    // Update validation to use dynamic phone regex
    const phoneRegex = getPhoneRegex(selectedCountry?.msisdnLength || 10);

    if (
      !firstName ||
      !lastName ||
      !emailId ||
      !emailRegex.test(emailId) ||
      !username ||
      !password ||
      !pass.test(password) ||
      !mobileNumber ||
      (mobileNumber && !phoneRegex.test(mobileNumber)) ||
      !role
    ) {
      setError(true);
    } else {
      setError(false);
      let payload = {
        firstName: firstName,
        lastName: lastName,
        email: emailId,
        mobileNo: `+${selectedCountry.phonecode}${mobileNumber}`, // Include country code
        userName: username,
        passwd: password,
        countryId: selectedCountry.id.toString(),
        operatorCode: "",
        usergroup: role,
        userId: getFromLocalStorage("userData")?.id,
      };

      const response = await CreateNewUser(payload);
      console.log("responseCreateUser", response);
      if (response?.statusDescription?.status == 200) {
        getAllData();
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
        setCreateUserModal(false);
        setCreateUserForm({
          firstName: "",
          lastName: "",
          emailId: "",
          password: "",
          mobileNumber: "",
          role: "",
        });
      } else {
        Swal.fire({
          icon: "info",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
      }
    }
  };

  const getAllRole = async () => {
    setLoaders((prev) => ({ ...prev, rolesLoader: true }));
    const response = await GetAllRoleList();
    if (response?.statusDescription?.status == 200) {
      setRoleList(response?.usermodel);
    } else {
      setRoleList([]);
    }
    setLoaders((prev) => ({ ...prev, rolesLoader: false }));
  };

  useEffect(() => {
    getAllRole();
  }, []);

  console.log("roleList", roleList);
  const filteredCountries = countryList.filter(country =>
    country.name.toLowerCase().includes(searchCountry.toLowerCase()) ||
    country.phonecode.toString().includes(searchCountry)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.phone-input-container')) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <form class="form-horizontal px-md-0 px-2" onSubmit={handleSubmit}>
      <div class="row mb-1">
        <div class="form-group col-sm-3">
          {/* <div class="form-group"> */}
            <label class="">
              First Name<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${error && !createUserForm.firstName ? "is-invalid" : ""
                }`}
              maxlength="100"
              name="firstName"
              placeholder="First Name"
              autocomplete="FirstName"
              value={createUserForm.firstName}
              onChange={(e) =>
                setCreateUserForm((prev) => ({
                  ...prev,
                  firstName: e.target.value,
                }))
              }
              onKeyPress={(e) => {
                if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {error && !createUserForm.firstName && (
              <div class="invalid-feedback d-block error">
                <div>First Name is required.</div>
              </div>
            )}
          {/* </div> */}
        </div>
        <div class="form-group col-sm-3">
          {/* <div class="form-group"> */}
            <label class="">
              Last Name<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${error && !createUserForm.lastName ? "is-invalid" : ""
                }`}
              autocomplete="LastName"
              placeholder="Last Name"
              maxlength="30"
              name="lastName"
              value={createUserForm.lastName}
              onChange={(e) =>
                setCreateUserForm((prev) => ({
                  ...prev,
                  lastName: e.target.value,
                }))
              }
              onKeyPress={(e) => {
                if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {error && !createUserForm.lastName && (
              <div class="invalid-feedback d-block error">
                <div>Last Name is required.</div>
              </div>
            )}
          {/* </div> */}
        </div>

        <div class="form-group col-sm-3">
          {/* <div class="form-group"> */}
            <label class="">
              Email Id<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${error &&
                (!createUserForm.emailId ||
                  !emailRegex.test(createUserForm.emailId))
                ? "is-invalid"
                : ""
                }`}
              autocomplete="EmailId"
              placeholder="Email Id"
              maxlength="70"
              name="emailId"
              value={createUserForm.emailId}
              onChange={(e) =>
                setCreateUserForm((prev) => ({
                  ...prev,
                  emailId: e.target.value,
                }))
              }
            />
            {error &&
              (!createUserForm.emailId ||
                !emailRegex.test(createUserForm.emailId)) && (
                <div className="invalid-feedback d-block error">
                  {!createUserForm.emailId
                    ? "Please enter an email id"
                    : createUserForm.emailId &&
                      !emailRegex.test(createUserForm.emailId)
                      ? "Please enter a valid email id"
                      : ""}
                </div>
              )}
          {/* </div> */}
        </div>
        <div class="form-group col-sm-3">
          {/* <div class="form-group"> */}
            <label class="">
              Username<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${error && !createUserForm.username ? "is-invalid" : ""
                }`}
              maxlength={100}
              // autocomplete="Username"
              placeholder="Username"
               autocomplete="nope"
              name="username"
              value={createUserForm.username}
              onChange={(e) =>
                setCreateUserForm((prev) => ({
                  ...prev,
                  username: e.target.value,
                }))
              }
            />
            {error && !createUserForm.username && (
              <div className="invalid-feedback d-block error">
                Please enter a username
              </div>
            )}
          {/* </div> */}
        </div>
        <div class="form-group col-sm-3">
          {/* <div class="form-group"> */}
            <div className="d-flex justify-content-between">
              <label class="">
                Password<sup class="text-danger">*</sup>
              </label>
             
            </div>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                class={`form-control ${error &&
                  (!createUserForm.password ||
                    !pass.test(createUserForm.password))
                  ? "is-invalid"
                  : ""
                  }`}
                // autocomplete="Password"
                autocomplete="nope"
                placeholder="Password"
                name="password"
                value={createUserForm.password}
                onChange={(e) =>
                  setCreateUserForm((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fas fa-eye${showPassword ? "" : "-slash"}`}
                  ></i>
                </span>
              </div>
            </div>
            {error &&
              (!createUserForm.password ||
                !pass.test(createUserForm.password)) && (
                <div className="invalid-feedback d-block error">
                  {!createUserForm.password
                    ? "Please enter a password"
                    : createUserForm.password &&
                      !pass.test(createUserForm.password)
                      ? "Password must has at least 8 characters that include at least 1 lowercase character, 1 uppercase characters, 1 number, and 1 special character"
                      : ""}
                </div>
              )}
          {/* </div> */}
        </div>

        <div class="form-group col-sm-3">
          {/* <div className="form-group"> */}
            <label className="">
              Mobile<sup className="text-danger">*</sup>
            </label>
            <div className="phone-input-container">
              <div
                className="phone-select"
                onClick={() => setShowCountryDropdown(!showCountryDropdown)}
              >
                {selectedCountry && (
                  <>
                    <img
                      src={`https://flagcdn.com/w20/${selectedCountry.iso.toLowerCase()}.png`}
                      alt={selectedCountry.nicename}
                      className="flag-icon"
                    />
                    <span className="country-code">
                      +{selectedCountry.phonecode}
                    </span>
                    <i className="fas fa-chevron-down arrow-icon"></i>
                  </>
                )}
              </div>
              <input
                type="text"
                className={`form-control mobile-input ${error &&
                  (!createUserForm.mobileNumber ||
                    !getPhoneRegex(selectedCountry?.msisdnLength || 10).test(createUserForm.mobileNumber))
                  ? "is-invalid"
                  : ""
                  }`}
                placeholder={`Enter ${selectedCountry?.msisdnLength || 10} digit number`}
                maxLength={selectedCountry?.msisdnLength || 10}
                value={createUserForm.mobileNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (
                    selectedCountry &&
                    value.length <= selectedCountry.msisdnLength
                  ) {
                    setCreateUserForm((prev) => ({
                      ...prev,
                      mobileNumber: value,
                    }));
                  }
                }}
              />

              {error &&
                (!createUserForm.mobileNumber ||
                  !getPhoneRegex(selectedCountry?.msisdnLength || 10).test(createUserForm.mobileNumber)) && (
                  <div className="invalid-feedback d-block">
                    {!createUserForm.mobileNumber
                      ? "Please enter a mobile number"
                      : `Please enter a valid ${selectedCountry?.msisdnLength}-digit mobile number`}
                  </div>
                )}

              {showCountryDropdown && (
                <div className="country-dropdown">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search country..."
                    value={searchCountry}
                    onChange={(e) => setSearchCountry(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div className="country-list">
                    {filteredCountries.map((country) => (
                      <div
                        key={country.id}
                        className={`country-item ${selectedCountry?.id === country.id ? 'active' : ''
                          }`}
                        onClick={() => {
                          setSelectedCountry(country);
                          setShowCountryDropdown(false);
                          setSearchCountry("");
                          // Clear mobile number when country changes
                          setCreateUserForm((prev) => ({
                            ...prev,
                            mobileNumber: "",
                          }));
                        }}
                      >
                        <img
                          src={`https://flagcdn.com/w20/${country.iso.toLowerCase()}.png`}
                          alt={country.nicename}
                          className="flag-icon"
                        />
                        <span className="country-name">{country.nicename}</span>
                        <span className="country-code">
                          +{country.phonecode}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          {/* </div> */}
        </div>
        <div class="form-group col-sm-3">
          {/* <div class="form-group"> */}
            <label class="">
              Select Role <sup class="text-danger">*</sup>
            </label>
            <div className="position-relative">
              <select
                class={`form-control ${error && !createUserForm.role ? "is-invalid" : ""
                  }`}
                name="role"
                formControlName="role"
                value={createUserForm.role}
                onChange={(e) =>
                  setCreateUserForm({
                    ...createUserForm,
                    role: e.target.value,
                  })
                }
                disabled={loaders.rolesLoader}
              >
                <option value="" selected>
                  {loaders.rolesLoader
                    ? "Loading roles..."
                    : "--Select Role --"}
                </option>
                {!loaders.rolesLoader &&
                  roleList &&
                  roleList?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
              </select>
              {loaders.rolesLoader && (
                <span className="sr-only">Loading...</span>
              )}
              <div className="dropdown-icon">
                <i
                  className="fas fa-chevron-down"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    display: loaders.rolesLoader ? "none" : "block",
                  }}
                ></i>
              </div>
            </div>
            {error && !createUserForm.role && (
              <span class="invalid-feedback d-block error">
                Role is required
              </span>
            )}
          {/* </div> */}
        </div>
      </div>

      {/* <div class="row"> */}

        
      {/* </div> */}


      <span className="password-title">Password must have:</span>
      <ul className="password-requirements">
        <li>At least 8 characters</li>
        <li> 1 lowercase character</li>
        <li> 1 uppercase character</li>
        <li> 1 number</li>
        <li> 1 special character</li>
      </ul>

      <div class="modal-footer pb-0 border-0 justify-content-between mx-0 px-0">
        <button
          type="button"
          class="btn btn-danger btn-raised m-0"
          data-dismiss="modal"
          onClick={() => {
            setCreateUserModal(false);
            setError(false);
            setCreateUserForm({
              firstName: "",
              lastName: "",
              emailId: "",
              password: "",
              mobileNumber: "",
              role: "",
            });
          }}
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-primary btn-raised m-0">
          Submit
        </button>
      </div>

    </form>
  );
};

export default CreateUser;
